export const INITIAL_LOAD_FIELD_KEY: string = ''
export const INITIAL_LOAD_FIELD_VALUE: number | null = null
